import React, { Fragment, useRef } from "react";
import _ from "lodash";
import RegisterFields from "./RegisterFileds";
import formFields from "./cpapServiceFormFileds";

export const CPAPServiceForm = (props) => {
  const inputRef = useRef({});

  const renderFields = () => {
    return _.map(formFields, ({ label, name, type, options, required }) => {
      return (
        <RegisterFields
          name={name}
          label={label}
          type={type}
          value={inputRef.current.name}
          options={options}
          required={required}
          onChange={props.onChange(name)}
        />
      );
    });
  };

  return <Fragment>{renderFields()}</Fragment>;
};
